import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {exhibitionScenarioActions} from "../../../actions/exhibition-scenario.actions";
import ExhibitionScenarioTable from "./_components/ExhibitionScenarioTable";
import ExhibitionScenarioForm from "./_forms/ExhibitionScenarioForm";
import {modalActions} from "../../../actions/modal.actions";

class ExhibitionScenarioPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(exhibitionScenarioActions.getListExhibitionScenario());
    }

    handleOpenCreateModal = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_exhibition-scenario'),
            component: <ExhibitionScenarioForm submit={this.handleSubmitCreateScenario} />
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'formModal'
        }));
    }

    handleSubmitCreateScenario = (model) => {
        const { dispatch } = this.props;
        dispatch(exhibitionScenarioActions.createExhibitionScenario(model));
    }

    render() {
        const breadcrumb = [{ value: 'exhibition-scenario', path: '#' }];
        const { t, exhibitionScenarioList } = this.props;

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4 className="col-md-6">{t('exhibition-scenario')}</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <button className="btn btn-success float-right btn-create" onClick={this.handleOpenCreateModal} >
                                <i className="fas fa-plus"> </i> &nbsp; { t('create') }
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <ExhibitionScenarioTable list={exhibitionScenarioList} />
                    </div>
                </div>
            </div>
        )
    }

}
const mapStateToProps = (state) => {
    const { exhibitionScenarioList } = state.exhibitionScenarioReducer;
    return {
        exhibitionScenarioList
    }
}
export default withNamespaces()(connect(mapStateToProps)(ExhibitionScenarioPage))